import {Component, Input} from "@angular/core";
import {HomePage} from "../../pages/home/home";
import {AlertController, NavController} from "ionic-angular";
import {LoginPage} from "../../pages/login/login";
import {ProfilePage} from "../../pages/profile/profile";
import {AccountProvider} from "../../providers/account/account";
import {TranslateService} from "@ngx-translate/core";

/**
 * Generated class for the NavComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: "nav",
    templateUrl: "nav.html",
    providers: [AccountProvider]
})
export class NavComponent {
    homePage = HomePage;
    loginPage = LoginPage;
    profilePage = ProfilePage;

    showSidebar = false;
    currentLanguage = 'vi';

    public profile = {};

    @Input() back = false;
    @Input() title: any = null;

    public isDemo = false;

    constructor(
        public navCtrl: NavController,
        public accountProvider: AccountProvider,
        public translate: TranslateService,
        public alertCtrl: AlertController
    ) {
        this.isDemo = window.localStorage.getItem("TOKEN_KEY") === 'demo';
        console.log("Hello NavComponent Component");
        this.loadProfile();

        this.currentLanguage = window.localStorage.getItem('LANG') || 'vi';

        setInterval(() => {
            this.loadProfile();
        },  30000);
    }

    goPage(page, params = {}) {
        this.navCtrl.push(page, params);
    }

    setRoot(page, params = {}) {
        this.navCtrl.setRoot(page, params);
    }

    signout() {
        window.localStorage.removeItem("TOKEN_KEY");
        this.navCtrl.setRoot(LoginPage);
    }

    loadProfile() {
        if (!window.localStorage.getItem("TOKEN_KEY") || window.localStorage.getItem("TOKEN_KEY") === 'demo') {
            return;
        }

        this.accountProvider.loadProfile().subscribe(
            (resp: any) => {
                if (!resp.status) {
                    return;
                }

                this.profile = resp.data;
            },
            err => {
                window.localStorage.removeItem("TOKEN_KEY");
                
                const alert = this.alertCtrl.create({
                    title: this.translate.instant("ALERT"),
                    subTitle: this.translate.instant("INVALID_TOKEN"),
                    buttons: [this.translate.instant("CLOSE")]
                });
                alert.present();
                this.navCtrl.setRoot(LoginPage);
            }
        );
    }

    changeLanguage(language = 'vi') {
        this.currentLanguage = language;
        window.localStorage.setItem('LANG', this.currentLanguage);

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translate.use(this.currentLanguage);
    }
}



// WEBPACK FOOTER //
// ./src/components/nav/nav.ts